import { schemaWalletUserId, schemaWalletInfo, schemaWalletCapabilities, } from "@ledgerhq/wallet-api-core";
export class WalletModule {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     *
     * @returns the userId
     *
     * @throws {@link ServerError} if an error occured on server side
     */
    async userId() {
        const userIdResult = await this.client.request("wallet.userId", {});
        const safeResults = schemaWalletUserId.result.parse(userIdResult);
        return safeResults.userId;
    }
    /**
     *
     * @returns The wallet infos
     *
     * @throws {@link ServerError} if an error occured on server side
     */
    async info() {
        const infoResult = await this.client.request("wallet.info", {});
        const safeResults = schemaWalletInfo.result.parse(infoResult);
        return safeResults;
    }
    /**
     * List the wallet's implemented methodIds
     *
     * @returns The list of implemented method ids
     * @throws {@link RpcError} if an error occured on server side
     *
     * @beta Filtering not yet implemented
     */
    async capabilities() {
        const walletCapabilitiesResult = await this.client.request("wallet.capabilities", {});
        const safeResults = schemaWalletCapabilities.result.parse(walletCapabilitiesResult);
        return safeResults.methodIds;
    }
}
//# sourceMappingURL=Wallet.js.map